import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=4fa4e322&scoped=true&"
import script from "./DashboardNavbar.vue?vue&type=script&lang=js&"
export * from "./DashboardNavbar.vue?vue&type=script&lang=js&"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&id=4fa4e322&lang=scss&scoped=true&"
import style1 from "./DashboardNavbar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa4e322",
  null
  
)

export default component.exports